// Adaptive Quiz bank: 3 difficulty tiers across ~15 questions per tier
// Used by AdaptiveQuiz.jsx — pulls random-without-repeat from current tier

export const ADAPTIVE_QUESTIONS = [
  // --- Tier 0: Beginner ---
  { tier: 0, q: "Bullish engulfing candle signals…", choices: ["Bearish continuation", "Bullish reversal potential", "Market halt", "No change"], correct: 1 },
  { tier: 0, q: "Support is…", choices: ["A price ceiling", "A price floor where buyers step in", "A moving average", "A type of order"], correct: 1 },
  { tier: 0, q: "RSI above 70 typically means…", choices: ["Oversold", "Overbought", "Neutral", "Volume spike"], correct: 1 },
  { tier: 0, q: "An uptrend prints…", choices: ["Lower highs", "Higher highs and higher lows", "Equal highs", "Random noise"], correct: 1 },
  { tier: 0, q: "Stop loss is used to…", choices: ["Guarantee profit", "Limit loss on a trade", "Double your position", "Remove emotions"], correct: 1 },

  // --- Tier 1: Intermediate ---
  { tier: 1, q: "Bullish divergence forms when…", choices: ["Price LL, RSI HL", "Price HH, RSI HH", "Price flat, RSI flat", "Price LL, RSI LL"], correct: 0 },
  { tier: 1, q: "A 1:3 R:R ratio means…", choices: ["Risk $3 to make $1", "Risk $1 to make $3", "Win 3/5 trades", "Stop is 3× target"], correct: 1 },
  { tier: 1, q: "Break of structure (BOS) signals…", choices: ["Trend continuation forever", "Potential market-structure shift once a swing breaks", "Just noise", "A candle closed red"], correct: 1 },
  { tier: 1, q: "Expectancy formula:", choices: ["Wins − Losses", "(WinRate × AvgWin) − (LossRate × AvgLoss)", "WinRate ÷ R:R", "Trades × Risk"], correct: 1 },
  { tier: 1, q: "2% risk on $5,000 =", choices: ["$50", "$100", "$200", "$500"], correct: 1 },

  // --- Tier 2: Advanced ---
  { tier: 2, q: "Setup: 4H shows HH/HL, 15m just printed a BOS to the downside near resistance. Best action?", choices: [
    "Enter long immediately — HTF bias is up",
    "Wait for LTF re-test of broken structure in alignment with HTF, or pass",
    "Short aggressively on BOS alone",
    "Add to longs without confirmation",
  ], correct: 1 },
  { tier: 2, q: "Your 3-month backtest shows 60% win rate, avg R 1.5, but live you're at 48% with avg R 1.1. Most likely cause?", choices: [
    "Market regime + rule deviations you haven't audited",
    "Broker manipulation",
    "Your stop is too tight — remove it",
    "Backtesting is useless",
  ], correct: 0 },
  { tier: 2, q: "EUR/USD sweeps yesterday's low then reclaims with strong bullish FVG at London open. Classical interpretation:", choices: [
    "Liquidity run then shift — look for longs on LTF confirmation",
    "Confirmed bearish trend continuation",
    "No information — ignore",
    "Always short on sweep",
  ], correct: 0 },
  { tier: 2, q: "You're down 4% on the week, 2 trades left on plan. Correct action:", choices: [
    "Size up to recover",
    "Skip remaining trades and audit the week",
    "Remove stop losses",
    "Switch strategy mid-week",
  ], correct: 1 },
  { tier: 2, q: "Position-size sanity: $10k acct, 1% risk, 40-pip stop, $1/pip per micro-lot. Correct size?", choices: [
    "1 standard lot",
    "2.5 micro-lots",
    "$100 risk ÷ 40 pips = 2.5 units @ $1/pip (0.25 mini / 2.5 micro-lots)",
    "Any size feels right",
  ], correct: 2 },
];

// Pick next question given current difficulty and already-asked ids
export function pickAdaptive(tier, askedIdx) {
  const pool = ADAPTIVE_QUESTIONS
    .map((q, i) => ({ q, i }))
    .filter(({ q, i }) => q.tier === tier && !askedIdx.includes(i));
  if (pool.length === 0) {
    // fallback: allow repeats within tier
    const anyPool = ADAPTIVE_QUESTIONS.map((q, i) => ({ q, i })).filter(({ q }) => q.tier === tier);
    return anyPool[Math.floor(Math.random() * anyPool.length)];
  }
  return pool[Math.floor(Math.random() * pool.length)];
}

export const TIER_LABEL = ["Beginner", "Intermediate", "Advanced"];
